import { render, staticRenderFns } from "./CancelAssetIssuance.vue?vue&type=template&id=3909f532"
import script from "./CancelAssetIssuance.vue?vue&type=script&lang=js"
export * from "./CancelAssetIssuance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports